import { useCallback, useState } from 'react';

export const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(forcedState =>
    setState(prevState => (forcedState != null ? forcedState : !prevState))
  );
  return [state, toggle];
};